// @generated from semantic profiles — do not edit manually
// Regenerate: npx tsx scripts/generate-nearley-grammar.ts
// Source: packages/semantic/src/generators/profiles/*.ts

/**
 * Keyword → language(s) lookup table for language detection.
 * Generated from 24 semantic language profiles.
 *
 * Used by the Nearley-based language detector (Phase 5.1).
 * Each keyword maps to the language(s) that use it as a command keyword.
 */
export const KEYWORD_LANGUAGE_MAP: Record<string, readonly string[]> = {
  '-kama': ['qu'],
  '-manta': ['qu'],
  a: ['es', 'pt', 'it', 'tr'],
  à: ['fr'],
  abrufen: ['de'],
  absenden: ['de'],
  'aç/kapat': ['tr'],
  accodare: ['it'],
  acha: ['sw'],
  acrescentar: ['pt'],
  activar: ['es'],
  add: ['en'],
  además: ['es'],
  adentro: ['es'],
  adicionar: ['pt'],
  afficher: ['fr'],
  after: ['en'],
  aggiungere: ['it'],
  aggiungi: ['it'],
  agregar: ['es'],
  aguardar: ['pt'],
  ajouter: ['fr'],
  ajukan: ['id'],
  akhir: ['id'],
  akllay: ['qu'],
  al: ['es', 'it', 'tr'],
  'além disso': ['pt'],
  alihkan: ['id'],
  alisin: ['tl'],
  alisin_tuon: ['tl'],
  aller: ['fr'],
  allora: ['it'],
  alors: ['fr'],
  alteração: ['pt'],
  alternar: ['es', 'pt'],
  alternare: ['it'],
  alterner: ['fr'],
  altrimenti: ['it'],
  ambatanisha: ['sw'],
  ambia: ['sw'],
  ambil: ['id', 'ms'],
  ambil_dari: ['ms'],
  ẩn: ['vi'],
  añadir: ['es'],
  anche: ['it'],
  anchuchiy: ['qu'],
  and: ['en'],
  andare: ['it'],
  ändern: ['de'],
  änderung: ['de'],
  andika: ['sw'],
  anexar: ['es', 'pt'],
  angazia: ['sw'],
  anhalten: ['de'],
  anhängen: ['de'],
  animar: ['es', 'pt'],
  animare: ['it'],
  animasikan: ['id'],
  animer: ['fr'],
  animieren: ['de'],
  animisha: ['sw'],
  animuj: ['pl'],
  annexer: ['fr'],
  anschließend: ['de'],
  ansonsten: ['de'],
  anteponer: ['es'],
  anteporre: ['it'],
  anterior: ['es'],
  antes: ['es', 'pt'],
  'antes de': ['es'],
  anza: ['sw'],
  anzeigen: ['de'],
  anzisha: ['sw'],
  ao: ['pt'],
  apabila: ['ms'],
  apachiy: ['qu'],
  apagar: ['pt'],
  apakuy: ['qu'],
  apamuy: ['qu'],
  apaykachay: ['qu'],
  apitar: ['pt'],
  appeler: ['fr'],
  append: ['en'],
  après: ['fr'],
  arahkan: ['id'],
  ardindan: ['tr'],
  ardından: ['tr'],
  arrêter: ['fr'],
  arrojar: ['es'],
  artır: ['tr'],
  as: ['en'],
  asenkron: ['tr'],
  asincrono: ['es', 'it'],
  asíncrono: ['es'],
  asinkron: ['id'],
  aspettare: ['it'],
  assíncrono: ['pt'],
  async: ['en', 'ru', 'pl', 'uk', 'tl'],
  asynchron: ['de'],
  asynchrone: ['fr'],
  asynchronicznie: ['pl'],
  at: ['tl'],
  até: ['pt'],
  ativar: ['pt'],
  attendere: ['it'],
  attendre: ['fr'],
  attivare: ['it'],
  atur: ['id'],
  au: ['fr'],
  auch: ['de'],
  auf: ['de'],
  aufrufen: ['de'],
  augmenter: ['fr'],
  aumentar: ['es', 'pt'],
  aumentare: ['it'],
  aus: ['de'],
  ausgeben: ['de'],
  auslösen: ['de'],
  aussi: ['fr'],
  austauschen: ['de'],
  auswählen: ['de'],
  avant: ['fr'],
  avec: ['fr'],
  awali: ['id'],
  ayarla: ['tr'],
  ayrıca: ['tr'],
  az: ['pl'],
  aż: ['pl'],
  azalt: ['tr'],
  baada: ['sw'],
  baadaye: ['sw'],
  badalisha: ['sw'],
  badilisha: ['sw'],
  'badilisha umbo': ['sw'],
  badilishana: ['sw'],
  bago: ['tl'],
  baguhin: ['tl'],
  bấm: ['vi'],
  basculer: ['fr'],
  başınaekle: ['tr'],
  başlat: ['tr'],
  'bất đồng bộ': ['vi'],
  'bật tắt': ['vi'],
  bawaan: ['id'],
  bawasan: ['tl'],
  beenden: ['de'],
  beep: ['en', 'it', 'vi'],
  before: ['en'],
  behavior: ['en'],
  bei: ['de'],
  bekle: ['tr'],
  bekommen: ['de'],
  belirle: ['tr'],
  berhenti: ['id', 'ms'],
  beritahu: ['id', 'ms'],
  berubah: ['id'],
  'biến đổi': ['vi'],
  bikin: ['id'],
  bila: ['id', 'ms'],
  bip: ['fr', 'tr'],
  bis: ['de'],
  bitiş: ['tr'],
  bitti: ['tr'],
  blur: ['en', 'id', 'sw'],
  bỏ: ['vi'],
  'bổ sung': ['vi'],
  borrar: ['es'],
  break: ['en'],
  buang: ['id', 'ms'],
  buat: ['id', 'ms'],
  bulanik: ['tr'],
  bulanık: ['tr'],
  bulanıklık: ['tr'],
  bumalik: ['tl'],
  bunyi: ['id', 'ms'],
  buscar: ['es', 'pt'],
  by: ['en'],
  cacher: ['fr'],
  çağır: ['tr'],
  'cài đặt': ['vi'],
  call: ['en'],
  cambiamento: ['it'],
  cambiar: ['es'],
  cambio: ['es', 'it'],
  carga: ['es'],
  catat: ['id', 'ms'],
  cercano: ['es'],
  cetak: ['id'],
  cetuskan: ['ms'],
  chagua: ['sw'],
  'chaguo-msingi': ['sw'],
  chamar: ['pt'],
  changement: ['fr'],
  chanqay: ['qu'],
  chaymanta: ['qu'],
  chaymantataq: ['qu'],
  chaymantawan: ['qu'],
  chaypim: ['qu'],
  che: ['vi'],
  chercher: ['fr'],
  chiamare: ['it'],
  cho: ['vi'],
  chờ: ['vi'],
  'cho đến khi': ['vi'],
  chochea: ['sw'],
  choisir: ['fr'],
  chọn: ['vi'],
  chora: ['sw'],
  chukua: ['sw'],
  churanay: ['qu'],
  churay: ['qu'],
  chuyển: ['vi'],
  'chuyển đổi': ['vi'],
  'chuyển tiếp': ['vi'],
  cipta: ['ms'],
  ciptakan: ['id'],
  çık: ['tr'],
  clic: ['es', 'fr', 'it'],
  clicar: ['pt'],
  clicca: ['it'],
  click: ['es'],
  clique: ['pt', 'fr'],
  clonar: ['es', 'pt'],
  clonare: ['it'],
  clone: ['en'],
  cloner: ['fr'],
  colocar: ['es', 'pt'],
  com: ['pt'],
  commutare: ['it'],
  comportamento: ['pt', 'it'],
  comportamiento: ['es'],
  comportement: ['fr'],
  con: ['es', 'it'],
  concentrer: ['fr'],
  configurar: ['pt'],
  conmutar: ['es'],
  conseguir: ['es'],
  continuar: ['es', 'pt'],
  continuare: ['it'],
  continue: ['en'],
  continuer: ['fr'],
  converter: ['pt'],
  convertir: ['es'],
  convertire: ['it'],
  copiar: ['es', 'pt'],
  copiare: ['it'],
  copier: ['fr'],
  copy: ['en'],
  crear: ['es'],
  creare: ['it'],
  créer: ['fr'],
  criar: ['pt'],
  cuando: ['es'],
  czekaj: ['pl'],
  da: ['it', 'tr'],
  dagdagan: ['tl'],
  'daha sonra': ['tr'],
  dalej: ['pl'],
  dan: ['tr', 'id', 'ms'],
  danach: ['de'],
  dann: ['de'],
  dans: ['fr'],
  dapatkan: ['id', 'ms'],
  dari: ['id', 'ms'],
  đặt: ['vi'],
  davranış: ['tr'],
  de: ['es', 'pt', 'fr', 'tr'],
  để: ['vi'],
  'de lo contrario': ['es'],
  decir: ['es'],
  déclencher: ['fr'],
  decrement: ['en'],
  decrementar: ['es', 'pt'],
  decrementare: ['it'],
  décrémenter: ['fr'],
  default: ['en', 'tl'],
  défaut: ['fr'],
  definieren: ['de'],
  definir: ['es', 'pt'],
  définir: ['fr'],
  definire: ['it'],
  défocaliser: ['fr'],
  defokussieren: ['de'],
  degil: ['tr'],
  değil: ['tr'],
  değişiklik: ['tr'],
  degisim: ['tr'],
  değişim: ['tr'],
  değiştir: ['tr'],
  den: ['tr'],
  đến: ['vi'],
  dengan: ['id', 'ms'],
  dentro: ['es', 'pt', 'it'],
  'dentro de': ['es', 'pt'],
  depois: ['pt'],
  depuis: ['fr'],
  desde: ['es', 'pt'],
  desenfocar: ['es'],
  desenfoque: ['es'],
  desfocar: ['pt'],
  desplazamiento: ['es'],
  despues: ['es'],
  después: ['es'],
  'despues de': ['es'],
  'después de': ['es'],
  detener: ['es'],
  devam: ['tr'],
  devolver: ['es', 'pt'],
  di: ['it', 'id'],
  đi: ['vi'],
  'di chuột': ['vi'],
  'đi đến': ['vi'],
  di_mana: ['id', 'ms'],
  diminuer: ['fr'],
  diminuir: ['pt'],
  diminuire: ['it'],
  dire: ['fr', 'it'],
  disminuir: ['es'],
  disparar: ['es', 'pt'],
  dizer: ['pt'],
  dla: ['pl'],
  do: ['pl'],
  'đo lường': ['vi'],
  dodaj: ['pl'],
  đổi: ['vi'],
  đợi: ['vi'],
  dolacz: ['pl'],
  dołącz: ['pl'],
  domyslnie: ['pl'],
  domyślnie: ['pl'],
  dön: ['tr'],
  donde: ['es'],
  dönüştür: ['tr'],
  dopo: ['it'],
  dopoki: ['pl'],
  dopóki: ['pl'],
  dove: ['it'],
  đưa: ['vi'],
  dừng: ['vi'],
  'dừng lại': ['vi'],
  duplicar: ['es'],
  dupliquer: ['fr'],
  duplizieren: ['de'],
  dur: ['tr'],
  durdur: ['tr'],
  durumunda: ['tr'],
  e: ['pt', 'it', 'tr'],
  échanger: ['fr'],
  également: ['fr'],
  eğer: ['tr'],
  eingabe: ['de'],
  ekle: ['tr'],
  elekea: ['sw'],
  eliminar: ['es', 'pt'],
  eliminare: ['it'],
  else: ['en'],
  em: ['pt'],
  en: ['es'],
  end: ['en'],
  enda: ['sw'],
  ende: ['de'],
  endelea: ['sw'],
  enfocar: ['es'],
  enfoque: ['es'],
  enlever: ['fr'],
  enquanto: ['pt'],
  enregistrer: ['fr'],
  enseñar: ['es'],
  ensuite: ['fr'],
  então: ['pt'],
  entfernen: ['de'],
  entfokussieren: ['de'],
  entonces: ['es'],
  entrada: ['es', 'pt'],
  entrée: ['fr'],
  enviar: ['es', 'pt'],
  envio: ['es', 'pt'],
  envío: ['es'],
  envoyer: ['fr'],
  ereignis: ['de'],
  erhöhen: ['de'],
  erstellen: ['de'],
  erzeugen: ['de'],
  es: ['es'],
  escoger: ['es'],
  escolher: ['pt'],
  esconder: ['es', 'pt'],
  esperar: ['es', 'pt'],
  estabilizar: ['es', 'pt'],
  establecer: ['es'],
  et: ['fr'],
  établir: ['fr'],
  événement: ['fr'],
  event: ['en', 'de', 'id'],
  evento: ['es', 'pt', 'it'],
  exibir: ['pt'],
  existe: ['es'],
  exit: ['en'],
  faire: ['fr'],
  falls: ['de'],
  fare: ['it'],
  fazer: ['pt'],
  fermare: ['it'],
  fertig: ['de'],
  festlegen: ['de'],
  fetch: ['en'],
  ficha: ['sw'],
  fijar: ['es'],
  fim: ['pt'],
  fin: ['es', 'fr'],
  final: ['es', 'pt'],
  fine: ['it'],
  finir: ['fr'],
  fino: ['it'],
  fırlat: ['tr'],
  focaliser: ['fr'],
  focalizzare: ['it'],
  focar: ['pt'],
  focus: ['en'],
  fokus: ['id', 'ms'],
  fokuskan: ['id'],
  fokussieren: ['de'],
  for: ['en'],
  fortfahren: ['de'],
  from: ['en'],
  fuera: ['es'],
  'fuera de': ['es'],
  für: ['de'],
  futa: ['sw'],
  galing: ['tl'],
  gán: ['vi'],
  ganti: ['id'],
  gdy: ['pl'],
  gdzie: ['pl'],
  geçiş: ['tr'],
  gehen: ['de'],
  get: ['en'],
  getir: ['tr'],
  geuza: ['sw'],
  giảm: ['vi'],
  'giảm đi': ['vi'],
  giấu: ['vi'],
  girdi: ['tr'],
  giris: ['tr'],
  giriş: ['tr'],
  git: ['tr'],
  gizle: ['tr'],
  go: ['en'],
  'gỡ bỏ': ['vi'],
  gọi: ['vi'],
  gönder: ['tr'],
  gönderme: ['tr'],
  göster: ['tr'],
  gửi: ['vi'],
  gumawa: ['tl'],
  habang: ['tl'],
  habis: ['ms'],
  hacer: ['es'],
  'hacer clic': ['es'],
  hadi: ['sw'],
  halafu: ['sw'],
  halt: ['en'],
  hamisha: ['sw'],
  hanggang: ['tl'],
  'hành vi': ['vi'],
  hantar: ['ms'],
  hapiy: ['qu'],
  hapus: ['id'],
  hasta: ['es'],
  'hasta que': ['es'],
  hawachiy: ['qu'],
  'hem de': ['tr'],
  henti: ['ms'],
  hentikan: ['id'],
  hide: ['en'],
  hiện: ['vi'],
  'hiển thị': ['vi'],
  hilangkan: ['id'],
  hinallataq: ['qu'],
  hinaspa: ['qu'],
  hinein: ['de'],
  hintay: ['tl'],
  hinzufügen: ['de'],
  'hoán đổi': ['vi'],
  holen: ['de'],
  hover: ['de', 'id', 'pl'],
  hukniraq: ['qu'],
  huminto: ['tl'],
  hurquy: ['qu'],
  i: ['tr', 'pl'],
  'i-clone': ['tl'],
  ibaba: ['tl'],
  ibalik: ['tl'],
  için: ['tr'],
  içine: ['tr'],
  idagdag: ['tl'],
  idagdag_sa_dulo: ['tl'],
  idagdag_sa_simula: ['tl'],
  idz: ['pl'],
  idź: ['pl'],
  if: ['en'],
  ihagis: ['tl'],
  ikabit: ['tl'],
  iken: ['tr'],
  ikiwa: ['sw'],
  ilagay: ['tl'],
  iliştir: ['tr'],
  ima: ['qu'],
  imarika: ['sw'],
  imayna: ['qu'],
  impostare: ['it'],
  imprimir: ['es', 'pt'],
  in: ['de', 'it', 'tr'],
  'in ra': ['vi'],
  inaczej: ['pl'],
  increment: ['en'],
  incrementar: ['es', 'pt'],
  incrementare: ['it'],
  incrémenter: ['fr'],
  inicializar: ['es', 'pt'],
  iniciar: ['es', 'pt'],
  inicjuj: ['pl'],
  inisialisasi: ['id'],
  init: ['en'],
  initialiser: ['fr'],
  initialisieren: ['de'],
  inizia: ['it'],
  inizializzare: ['it'],
  input: ['it', 'id', 'pl'],
  inserção: ['pt'],
  inserimento: ['it'],
  inserire: ['it'],
  instal: ['id'],
  instalar: ['es', 'pt'],
  install: ['en'],
  installare: ['it'],
  installer: ['fr'],
  installieren: ['de'],
  intercambiar: ['es'],
  interromper: ['pt'],
  interrompere: ['it'],
  interrompre: ['fr'],
  into: ['en'],
  introducir: ['es'],
  inviare: ['it'],
  invio: ['it'],
  ipadala: ['tl'],
  ipakita: ['tl'],
  ir: ['es', 'pt'],
  irender: ['tl'],
  'isiyo sawia': ['sw'],
  ita: ['sw'],
  itago: ['tl'],
  itakda: ['tl'],
  itala: ['tl'],
  itapon: ['tl'],
  itigil: ['tl'],
  itoggle: ['tl'],
  ituon: ['tl'],
  ı: ['tr'],
  ın: ['tr'],
  jalankan: ['id'],
  javascript: ['de', 'id', 'sw'],
  jesli: ['pl'],
  jeśli: ['pl'],
  jezeli: ['pl'],
  jeżeli: ['pl'],
  jika: ['id', 'ms'],
  jika_tidak: ['ms'],
  journaliser: ['fr'],
  js: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  js실행: ['ko'],
  js実行: ['ja'],
  js执行: ['zh'],
  juga: ['id'],
  "jusqu'à": ['fr'],
  jusque: ['fr'],
  kabla: ['sw'],
  kabur: ['ms'],
  kachay: ['qu'],
  kadar: ['tr'],
  kadri: ['sw'],
  kalau: ['id', 'ms'],
  kalau_tidak: ['ms'],
  kaldır: ['tr'],
  kama: ['sw', 'qu'],
  kamay: ['qu'],
  kamaykuy: ['qu'],
  kambiay: ['qu'],
  kapag: ['tl'],
  katakan: ['id'],
  kaydet: ['tr'],
  kaykamaqa: ['qu'],
  kaypi: ['qu'],
  kazdy: ['pl'],
  każdy: ['pl'],
  ke: ['id', 'ms'],
  'ke dalam': ['id'],
  ke_dalam: ['ms'],
  kelakuan: ['ms'],
  keluar: ['id', 'ms'],
  kembali: ['id', 'ms'],
  kembalikan: ['id'],
  kemudian: ['id', 'ms'],
  'kết thúc': ['vi'],
  'kết xuất': ['vi'],
  ketika: ['id', 'ms'],
  khi: ['vi'],
  khỏi: ['vi'],
  'khởi tạo': ['vi'],
  'không thì': ['vi'],
  'kích hoạt': ['vi'],
  kichay: ['qu'],
  kiedy: ['pl'],
  kikinchay: ['qu'],
  kilos: ['tl'],
  kirim: ['id'],
  kirimkan: ['id'],
  kisha: ['sw'],
  klick: ['de'],
  klicken: ['de'],
  klik: ['id', 'pl'],
  klikniecie: ['pl'],
  kliknięciu: ['pl'],
  klon: ['id', 'ms'],
  klonen: ['de'],
  klonla: ['tr'],
  koniec: ['pl'],
  kontynuuj: ['pl'],
  kopieren: ['de'],
  kopiuj: ['pl'],
  kopyahin: ['tl'],
  kopyala: ['tr'],
  koy: ['tr'],
  kuhanin_mula: ['tl'],
  kumuha: ['tl'],
  kundi: ['tl'],
  kung: ['tl'],
  kung_hindi: ['tl'],
  kung_saan: ['tl'],
  kunin: ['tl'],
  kunin_mula: ['tl'],
  kur: ['tr'],
  kurang_satu: ['ms'],
  kurangi: ['id'],
  kutichiy: ['qu'],
  kutimuy: ['qu'],
  kutipay: ['qu'],
  kutoka: ['sw'],
  kuyuchiy: ['qu'],
  kwa: ['sw'],
  kwenye: ['sw'],
  la: ['tr'],
  laden: ['de'],
  lalai: ['ms'],
  lalu: ['id'],
  lançar: ['pt'],
  lancer: ['fr'],
  lanciare: ['it'],
  lanjutkan: ['id'],
  lanzar: ['es'],
  'lặp lại': ['vi'],
  lấy: ['vi'],
  'lấy giá trị': ['vi'],
  le: ['tr'],
  lempar: ['id', 'ms'],
  lenga: ['sw'],
  lepas: ['ms'],
  lepas_itu: ['ms'],
  leta: ['sw'],
  letak: ['ms'],
  letakkan: ['id', 'ms'],
  lia: ['sw'],
  llamar: ['es'],
  lluqsiy: ['qu'],
  'loại bỏ': ['vi'],
  log: ['en', 'ms'],
  logo: ['pt'],
  loguj: ['pl'],
  lors: ['fr'],
  löschen: ['de'],
  lúc: ['vi'],
  luego: ['es'],
  lumabas: ['tl'],
  lumikha: ['tl'],
  lumipat: ['tl'],
  'mặc định': ['vi'],
  machen: ['de'],
  'mag-install': ['tl'],
  magdagdag: ['tl'],
  maghintay: ['tl'],
  maglagay: ['tl'],
  magpadala: ['tl'],
  magpakita: ['tl'],
  magpalit: ['tl'],
  magpatahimik: ['tl'],
  magpatugtog: ['tl'],
  magpatuloy: ['tl'],
  magsabi: ['tl'],
  magsimula: ['tl'],
  magtago: ['tl'],
  magtakda: ['tl'],
  make: ['en'],
  maliza: ['sw'],
  man: ['qu'],
  'mana qhawachiy': ['qu'],
  'mana waqtalla': ['qu'],
  manachus: ['qu'],
  manta: ['qu'],
  masquer: ['fr'],
  masuk: ['id'],
  masukkan: ['id'],
  'mất tập trung': ['vi'],
  matapos: ['tl'],
  maykama: ['qu'],
  maypi: ['qu'],
  measure: ['en'],
  medir: ['es', 'pt'],
  mentre: ['it'],
  messen: ['de'],
  mesurer: ['fr'],
  métamorphoser: ['fr'],
  mettere: ['it'],
  mettre: ['fr'],
  mficho: ['sw'],
  mientras: ['es'],
  misurare: ['it'],
  mit: ['de'],
  modifier: ['fr'],
  montrer: ['fr'],
  morph: ['en'],
  mostrar: ['es', 'pt'],
  mostrare: ['it'],
  muat: ['id', 'ms'],
  mudança: ['pt'],
  mula: ['ms', 'tl'],
  mula_sa: ['tl'],
  mulai: ['id'],
  mulakan: ['ms'],
  muyu: ['qu'],
  mwisho: ['sw'],
  na: ['tr', 'pl', 'sw'],
  nach: ['de'],
  naikkan: ['id'],
  najechaniu: ['pl'],
  nakala: ['sw'],
  nakili: ['sw'],
  nang: ['tl'],
  nascondere: ['it'],
  nastepnie: ['pl'],
  następnie: ['pl'],
  navegar: ['es', 'pt'],
  navigare: ['it'],
  navigasi: ['id'],
  navigieren: ['de'],
  naviguer: ['fr'],
  nawiguj: ['pl'],
  ñawpachiy: ['qu'],
  ñawpaq: ['qu'],
  ndani: ['sw'],
  ne: ['tr'],
  nehmen: ['de'],
  ném: ['vi'],
  nenda: ['sw'],
  nerede: ['tr'],
  nếu: ['vi'],
  'nếu không': ['vi'],
  ngắt: ['vi'],
  ngoja: ['sw'],
  nhận: ['vi'],
  'nhân bản': ['vi'],
  nhấp: ['vi'],
  nhập: ['vi'],
  'nhập liệu': ['vi'],
  ni: ['tr'],
  nin: ['tr'],
  ñitiy: ['qu'],
  niy: ['qu'],
  nı: ['tr'],
  nın: ['tr'],
  no: ['es'],
  nối: ['vi'],
  'nói với': ['vi'],
  nộp: ['vi'],
  nu: ['tr'],
  nü: ['tr'],
  nun: ['tr'],
  nün: ['tr'],
  o: ['es'],
  ở_đâu: ['vi'],
  obtener: ['es'],
  obtenir: ['fr'],
  obter: ['pt'],
  ocultar: ['es', 'pt'],
  od: ['pl'],
  odak: ['tr'],
  odaklanma: ['tr'],
  odskup: ['pl'],
  okresl: ['pl'],
  określ: ['pl'],
  olah: ['id'],
  olay: ['tr'],
  ölç: ['tr'],
  olduğunda: ['tr'],
  on: ['en'],
  'ổn định': ['vi'],
  önce: ['tr'],
  onde: ['pt'],
  ondoa: ['sw'],
  ongeza: ['sw'],
  ongezeko: ['sw'],
  onyesha: ['sw'],
  oraz: ['pl'],
  ottenere: ['it'],
  où: ['fr'],
  "p'akiy": ['qu'],
  pa: ['qu'],
  pada: ['id', 'ms'],
  padam: ['ms'],
  padrão: ['pt'],
  padre: ['es'],
  pagkatapos: ['tl'],
  pakakuy: ['qu'],
  pakay: ['qu'],
  pakia: ['sw'],
  palitan: ['tl'],
  palitan_pwesto: ['tl'],
  palitawin: ['tl'],
  pamantayan: ['tl'],
  panggil: ['id', 'ms'],
  pangyayari: ['tl'],
  papar: ['ms'],
  paqariy: ['qu'],
  para: ['es', 'pt'],
  para_sa: ['tl'],
  parar: ['es', 'pt'],
  pasang: ['id', 'ms'],
  'pasar por encima': ['es'],
  pasay: ['qu'],
  passaggio: ['it'],
  passar: ['pt'],
  pata: ['sw'],
  'paulit-ulit': ['tl'],
  pecah: ['ms'],
  pegar: ['pt'],
  peleka: ['sw'],
  pendant: ['fr'],
  per: ['it'],
  peralihan: ['ms'],
  pergi: ['id', 'ms'],
  perilaku: ['id'],
  peristiwa: ['id', 'ms'],
  perlihatkan: ['id'],
  permutar: ['es'],
  permuter: ['fr'],
  peroleh: ['id'],
  pi: ['qu'],
  pia: ['sw'],
  pick: ['en'],
  picu: ['id'],
  piepton: ['de'],
  pilih: ['id', 'ms'],
  pima: ['sw'],
  pindah: ['id', 'ms'],
  pisiyachiy: ['qu'],
  pitido: ['es'],
  placer: ['fr'],
  platzieren: ['de'],
  po: ['pl'],
  pobierz: ['pl'],
  poczekaj: ['pl'],
  podczas: ['pl'],
  poi: ['it'],
  pokaz: ['pl'],
  pokaż: ['pl'],
  pokea: ['sw'],
  pon: ['es'],
  poner: ['es'],
  poprzedz: ['pl'],
  poprzedź: ['pl'],
  por: ['pt'],
  pôr: ['pt'],
  'por defecto': ['es'],
  potem: ['pl'],
  pour: ['fr'],
  powiedz: ['pl'],
  powtorz: ['pl'],
  powtórz: ['pl'],
  preceder: ['pt'],
  predefinito: ['it'],
  predeterminar: ['es'],
  préfixer: ['fr'],
  prendere: ['it'],
  prendre: ['fr'],
  prepend: ['en'],
  prima: ['it'],
  primera: ['es'],
  primero: ['es'],
  protokollieren: ['de'],
  przed: ['pl'],
  przejdz: ['pl'],
  przejdź: ['pl'],
  przejscie: ['pl'],
  przejście: ['pl'],
  przeksztalc: ['pl'],
  przekształć: ['pl'],
  przelacz: ['pl'],
  przełącz: ['pl'],
  przerwij: ['pl'],
  przy: ['pl'],
  puchukay: ['qu'],
  puis: ['fr'],
  pulang: ['ms'],
  pumili: ['tl'],
  pumunta: ['tl'],
  punguza: ['sw'],
  punta: ['tl'],
  puriy: ['qu'],
  put: ['en'],
  putulin: ['tl'],
  putuskan: ['id'],
  qallarichiy: ['qu'],
  qallariy: ['qu'],
  qatichiy: ['qu'],
  qatipay: ['qu'],
  qawachiy: ['qu'],
  qayay: ['qu'],
  qhawachiy: ['qu'],
  qhaway: ['qu'],
  qhipa: ['qu'],
  qhipaman_yapay: ['qu'],
  qichuy: ['qu'],
  qillqakuy: ['qu'],
  qillqay: ['qu'],
  quand: ['fr'],
  quando: ['pt', 'it'],
  quindi: ['it'],
  quitar: ['es'],
  rantikunakuy: ['qu'],
  rantin_tikray: ['qu'],
  'raton encima': ['es'],
  'ratón encima': ['es'],
  'raton fuera': ['es'],
  'ratón fuera': ['es'],
  'rê chuột': ['vi'],
  recuperar: ['es'],
  recuperare: ['it'],
  récupérer: ['fr'],
  registrar: ['es', 'pt'],
  registrare: ['it'],
  rejea: ['sw'],
  rekam: ['id'],
  rekodi: ['sw'],
  remove: ['en'],
  remover: ['es', 'pt'],
  render: ['en', 'tr'],
  renderizar: ['es', 'pt'],
  renderizzare: ['it'],
  rendern: ['de'],
  renderuj: ['pl'],
  rendu: ['fr'],
  renvoyer: ['fr'],
  repeat: ['en'],
  répéter: ['fr'],
  repetir: ['es', 'pt'],
  retirer: ['fr'],
  retornar: ['es', 'pt'],
  retourner: ['fr'],
  return: ['en'],
  rikuchiy: ['qu'],
  rikurichiy: ['qu'],
  rimuovere: ['it'],
  ripetere: ['it'],
  ritornare: ['it'],
  riy: ['qu'],
  rồi: ['vi'],
  romper: ['es'],
  rozmyj: ['pl'],
  rudia: ['sw'],
  rudisha: ['sw'],
  rudufu: ['sw'],
  ruray: ['qu'],
  ruwakuq: ['qu'],
  ruwana: ['qu'],
  rzuc: ['pl'],
  rzuć: ['pl'],
  sa: ['tl'],
  saat: ['id'],
  sabihin: ['tl'],
  sabitlen: ['tr'],
  sacar: ['es'],
  sagen: ['de'],
  sair: ['pt'],
  saisie: ['fr'],
  saka: ['tl'],
  sakinisha: ['sw'],
  salin: ['id', 'ms'],
  salir: ['es'],
  sampai: ['id', 'ms'],
  'sao chép': ['vi'],
  sapankaq: ['qu'],
  sau: ['vi'],
  'sau đó': ['vi'],
  'sau khi': ['vi'],
  sayay: ['qu'],
  scambiare: ['it'],
  scatenare: ['it'],
  scegliere: ['it'],
  schicken: ['de'],
  schowaj: ['pl'],
  schweben: ['de'],
  se: ['pt', 'it'],
  sebelum: ['id', 'ms'],
  seç: ['tr'],
  sehingga: ['ms'],
  'şekil değiştir': ['tr'],
  selagi: ['ms'],
  selainnya: ['id'],
  selama: ['id'],
  selepas: ['ms'],
  selesai: ['id', 'ms'],
  sema: ['sw'],
  semasa: ['ms'],
  sembunyi: ['ms'],
  sembunyikan: ['id'],
  senão: ['pt'],
  send: ['en'],
  senden: ['de'],
  serta: ['id'],
  sesudah: ['id'],
  set: ['en'],
  setelah: ['id'],
  'setelah itu': ['id'],
  seti: ['sw'],
  setkan: ['ms'],
  settle: ['en'],
  setzen: ['de'],
  sfuocare: ['it'],
  show: ['en'],
  si: ['es', 'fr'],
  sichus: ['qu'],
  siguiente: ['es'],
  sil: ['tr'],
  simama: ['sw'],
  simulan: ['tl'],
  sino: ['es'],
  sinon: ['fr'],
  sisipkan: ['id'],
  sivyo: ['sw'],
  sklonuj: ['pl'],
  skup: ['pl'],
  skupienie: ['pl'],
  sobre: ['es'],
  sobrevoar: ['pt'],
  sobrevolar: ['es'],
  sofern: ['de'],
  solange: ['de'],
  someter: ['es'],
  son: ['tr'],
  sonra: ['tr'],
  sonst: ['de'],
  sorok: ['ms'],
  sortir: ['fr'],
  sorvolo: ['it'],
  sottomettere: ['it'],
  soumettre: ['fr'],
  soumission: ['fr'],
  sowie: ['de'],
  söyle: ['tr'],
  stabiliser: ['fr'],
  stabilisieren: ['de'],
  stabilizzare: ['it'],
  stabilkan: ['id'],
  standard: ['de'],
  stellen: ['de'],
  stop: ['pl'],
  stoppen: ['de'],
  stopper: ['fr'],
  stworz: ['pl'],
  stwórz: ['pl'],
  su: ['it'],
  'sự kiện': ['vi'],
  subiri: ['sw'],
  submeter: ['pt'],
  submit: ['pl'],
  substituir: ['pt'],
  sukatin: ['tl'],
  supprimer: ['fr'],
  sur: ['fr'],
  süresince: ['tr'],
  survol: ['fr'],
  survoler: ['fr'],
  suyay: ['qu'],
  swap: ['en'],
  sygnał: ['pl'],
  "t'ikray": ['qu'],
  "t'inkuy": ['qu'],
  ta: ['tr', 'qu'],
  taasan: ['tl'],
  tabia: ['sw'],
  tải: ['vi'],
  tak_segerak: ['ms'],
  takas: ['tr'],
  take: ['en'],
  tamat: ['id', 'ms'],
  tamati: ['sw'],
  tambah: ['id', 'ms'],
  tambah_hujung: ['ms'],
  tambah_mula: ['ms'],
  tambah_satu: ['ms'],
  tambahkan: ['id'],
  também: ['pt'],
  también: ['es'],
  tampilkan: ['id'],
  tan: ['tr'],
  tăng: ['vi'],
  'tăng lên': ['vi'],
  tanggalin: ['tl'],
  tanguliza: ['sw'],
  tạo: ['vi'],
  'tập trung': ['vi'],
  tapos: ['tl'],
  taripakaramuy: ['qu'],
  taripay: ['qu'],
  tarpuy: ['qu'],
  taruh: ['id'],
  tauschen: ['de'],
  tawagan: ['tl'],
  tawagin: ['tl'],
  te: ['tr'],
  'tecla abajo': ['es'],
  'tecla arriba': ['es'],
  tekan: ['id'],
  tekrarla: ['tr'],
  tell: ['en'],
  ten: ['tr'],
  tengeneza: ['sw'],
  terminar: ['es'],
  terminer: ['fr'],
  término: ['pt'],
  terus: ['id'],
  teruskan: ['ms'],
  tetapkan: ['id', 'ms'],
  tetikle: ['tr'],
  'thay đổi': ['vi'],
  thêm: ['vi'],
  'thêm vào đầu': ['vi'],
  then: ['en'],
  thì: ['vi'],
  'thiết lập': ['vi'],
  thoát: ['vi'],
  throw: ['en'],
  tia: ['sw'],
  'tiếp tục': ['vi'],
  tik: ['tr'],
  tiklama: ['tr'],
  tikray: ['qu'],
  tingkatkan: ['id'],
  tiru: ['id'],
  tiyachiy: ['qu'],
  tiyakuy: ['qu'],
  tık: ['tr'],
  tıkla: ['tr'],
  tıklama: ['tr'],
  to: ['en'],
  toa: ['sw'],
  toggle: ['en', 'es'],
  togliere: ['it'],
  togol: ['ms'],
  toka: ['sw'],
  tomar: ['es'],
  'trả về': ['vi'],
  transformar: ['es', 'pt'],
  transformasi: ['id'],
  transformer: ['fr'],
  transformieren: ['de'],
  transição: ['pt'],
  transición: ['es'],
  transisi: ['id'],
  transition: ['en', 'fr'],
  transizione: ['it'],
  trasformare: ['it'],
  trên: ['vi'],
  trigger: ['en'],
  trocar: ['pt'],
  'trong khi': ['vi'],
  trước: ['vi'],
  'trước khi': ['vi'],
  từ: ['vi'],
  tukar: ['id', 'ms'],
  tukar_tempat: ['ms'],
  tukio: ['sw'],
  tukukuy: ['qu'],
  tukunay: ['qu'],
  tukuy: ['qu'],
  tulia: ['sw'],
  tuma: ['sw'],
  tumawag: ['tl'],
  tunggu: ['id', 'ms'],
  tunjuk: ['ms'],
  tunog: ['tl'],
  tupa: ['sw'],
  tupuy: ['qu'],
  turunkan: ['id'],
  tut: ['tr'],
  tutup: ['id'],
  tuwing: ['tl'],
  u: ['tr'],
  ü: ['tr'],
  ubah: ['id'],
  ubah_bentuk: ['ms'],
  übergang: ['de'],
  ugali: ['tl'],
  ukryj: ['pl'],
  ukuman: ['qu'],
  ukur: ['id', 'ms'],
  ulang: ['ms'],
  ulangi: ['id'],
  ulitin: ['tl'],
  ultima: ['es'],
  último: ['es'],
  umiesc: ['pl'],
  umieść: ['pl'],
  umschalten: ['de'],
  un: ['tr'],
  ün: ['tr'],
  unang_halaga: ['tl'],
  unapo: ['sw'],
  und: ['de'],
  unda: ['sw'],
  unterbrechen: ['de'],
  until: ['en'],
  untuk: ['id', 'ms'],
  uscire: ['it'],
  using: ['en'],
  ustabilizuj: ['pl'],
  ustaw: ['pl'],
  usun: ['pl'],
  usuń: ['pl'],
  utworz: ['pl'],
  utwórz: ['pl'],
  üzerinde: ['tr'],
  'üzerinde gezinme': ['tr'],
  'üzerine gelme': ['tr'],
  uzyskaj: ['pl'],
  và: ['vi'],
  vacio: ['es'],
  vacío: ['es'],
  vai: ['it'],
  vào: ['vi'],
  'vào trong': ['vi'],
  varsayılan: ['tr'],
  ve: ['tr'],
  verbergen: ['de'],
  verhalten: ['de'],
  vermindern: ['de'],
  verringern: ['de'],
  verstecken: ['de'],
  vertauschen: ['de'],
  verwandeln: ['de'],
  veya: ['tr'],
  via: ['en'],
  vilevile: ['sw'],
  vinginevyo: ['sw'],
  visualizzare: ['it'],
  với: ['vi'],
  'với mỗi': ['vi'],
  von: ['de'],
  vor: ['de'],
  voranstellen: ['de'],
  vunja: ['sw'],
  w: ['pl'],
  während: ['de'],
  wait: ['en'],
  wakas: ['tl'],
  wakati: ['sw'],
  wan: ['qu'],
  wapi: ['sw'],
  waqay: ['qu'],
  waqyay: ['qu'],
  warten: ['de'],
  wechseln: ['de'],
  weiter: ['de'],
  weka: ['sw'],
  wenn: ['de'],
  werfen: ['de'],
  wez: ['pl'],
  weź: ['pl'],
  when: ['en'],
  where: ['en'],
  while: ['en'],
  wiederholen: ['de'],
  willakuy: ['qu'],
  with: ['en'],
  wo: ['de'],
  wpp: ['pl'],
  wprowadzeniu: ['pl'],
  wstaw: ['pl'],
  wtedy: ['pl'],
  wybierz: ['pl'],
  wyczysc: ['pl'],
  wyczyść: ['pl'],
  wyjdź: ['pl'],
  wypisz: ['pl'],
  wyslaniu: ['pl'],
  wysłaniu: ['pl'],
  wyslij: ['pl'],
  wyślij: ['pl'],
  wyswietl: ['pl'],
  wyświetl: ['pl'],
  wywolaj: ['pl'],
  wywołaj: ['pl'],
  wyzwol: ['pl'],
  wyzwól: ['pl'],
  xóa: ['vi'],
  y: ['es'],
  ya: ['tr'],
  yap: ['tr'],
  yapachiy: ['qu'],
  yapay: ['qu'],
  yapaykuy: ['qu'],
  yaykuchiy: ['qu'],
  ye: ['tr'],
  yi: ['tr'],
  yı: ['tr'],
  yla: ['tr'],
  yle: ['tr'],
  yoksa: ['tr'],
  yu: ['tr'],
  yü: ['tr'],
  yükle: ['tr'],
  yüklemek: ['tr'],
  z: ['pl'],
  zachowanie: ['pl'],
  zainstaluj: ['pl'],
  zaladuj: ['pl'],
  załaduj: ['pl'],
  zaman: ['tr'],
  zamien: ['pl'],
  zamień: ['pl'],
  zatrzymaj: ['pl'],
  zdarzenie: ['pl'],
  ze: ['pl'],
  zeigen: ['de'],
  zmiana: ['pl'],
  zmianie: ['pl'],
  zmierz: ['pl'],
  zmniejsz: ['pl'],
  zu: ['de'],
  zurückgeben: ['de'],
  zwieksz: ['pl'],
  zwiększ: ['pl'],
  zwroc: ['pl'],
  zwróć: ['pl'],
  анимировать: ['ru'],
  анимируй: ['ru'],
  анімувати: ['uk'],
  анімуй: ['uk'],
  асинхронно: ['ru', 'uk'],
  бросить: ['ru'],
  брось: ['ru'],
  в: ['ru', 'uk'],
  введенні: ['uk'],
  введення: ['uk'],
  ввод: ['ru'],
  вводе: ['ru'],
  верни: ['ru'],
  вернуть: ['ru'],
  взяти: ['uk'],
  взять: ['ru'],
  вибрати: ['uk'],
  видали: ['uk'],
  видалити: ['uk'],
  вийти: ['uk'],
  викликати: ['uk'],
  виклич: ['uk'],
  виміряй: ['uk'],
  виміряти: ['uk'],
  від: ['uk'],
  відобразити: ['uk'],
  відправка: ['uk'],
  відправці: ['uk'],
  візьми: ['uk'],
  во: ['ru'],
  возьми: ['ru'],
  встав: ['uk'],
  вставити: ['uk'],
  вставить: ['ru'],
  вставь: ['ru'],
  встанови: ['uk'],
  встановити: ['uk'],
  встановити_пакет: ['uk'],
  выбрать: ['ru'],
  вызвать: ['ru'],
  вызови: ['ru'],
  выйти: ['ru'],
  где: ['ru'],
  далі: ['uk'],
  де: ['uk'],
  для: ['ru', 'uk'],
  до: ['ru', 'uk'],
  добавить: ['ru'],
  добавить_в_конец: ['ru'],
  добавить_в_начало: ['ru'],
  добавь: ['ru'],
  додай: ['uk'],
  додати: ['uk'],
  додати_в_кінець: ['uk'],
  додати_на_початок: ['uk'],
  дописати: ['uk'],
  дописать: ['ru'],
  если: ['ru'],
  ждать: ['ru'],
  жди: ['ru'],
  з: ['uk'],
  за_замовчуванням: ['uk'],
  завантаж: ['uk'],
  завантажити: ['uk'],
  загрузи: ['ru'],
  загрузить: ['ru'],
  задай: ['ru', 'uk'],
  задати: ['uk'],
  задать: ['ru'],
  записати: ['uk'],
  записать: ['ru'],
  запиши: ['ru', 'uk'],
  запусти: ['ru', 'uk'],
  запустити: ['uk'],
  запустить: ['ru'],
  затем: ['ru'],
  зачекай: ['uk'],
  збільш: ['uk'],
  збільшити: ['uk'],
  звук: ['ru', 'uk'],
  зменш: ['uk'],
  зменшити: ['uk'],
  зміна: ['uk'],
  зміні: ['uk'],
  зупинись: ['uk'],
  зупинити: ['uk'],
  и: ['ru'],
  иди: ['ru'],
  идти: ['ru'],
  из: ['ru'],
  изменение: ['ru'],
  изменении: ['ru'],
  измерить: ['ru'],
  измерь: ['ru'],
  иначе: ['ru'],
  инициализировать: ['ru'],
  инициализируй: ['ru'],
  инициировать: ['ru'],
  і: ['uk'],
  із: ['uk'],
  інакше: ['uk'],
  ініціалізувати: ['uk'],
  ініціалізуй: ['uk'],
  ініціювати: ['uk'],
  йди: ['uk'],
  йти: ['uk'],
  к: ['ru'],
  каждый: ['ru'],
  кинути: ['uk'],
  кинь: ['uk'],
  кінець: ['uk'],
  клик: ['ru'],
  клике: ['ru'],
  клік: ['uk'],
  кліку: ['uk'],
  клонировать: ['ru'],
  клонируй: ['ru'],
  клонувати: ['uk'],
  клонуй: ['uk'],
  когда: ['ru'],
  кожний: ['uk'],
  коли: ['uk'],
  конец: ['ru'],
  копировать: ['ru'],
  копіювати: ['uk'],
  на: ['ru', 'uk'],
  наведение: ['ru'],
  наведении: ['ru'],
  наведенні: ['uk'],
  наведення: ['uk'],
  надіслати: ['uk'],
  надішли: ['uk'],
  нажатии: ['ru'],
  натисканні: ['uk'],
  остановись: ['ru'],
  остановить: ['ru'],
  от: ['ru'],
  отобразить: ['ru'],
  отправить: ['ru'],
  отправка: ['ru'],
  отправке: ['ru'],
  отправь: ['ru'],
  отримай: ['uk'],
  отримати: ['uk'],
  перед: ['ru', 'uk'],
  перейди: ['ru', 'uk'],
  перейти: ['ru', 'uk'],
  переключи: ['ru'],
  переключить: ['ru'],
  перемкни: ['uk'],
  перемкнути: ['uk'],
  перервати: ['uk'],
  після: ['uk'],
  по_умолчанию: ['ru'],
  поведение: ['ru'],
  поведінка: ['uk'],
  поверни: ['uk'],
  повернути: ['uk'],
  повтори: ['ru', 'uk'],
  повторити: ['uk'],
  повторить: ['ru'],
  подія: ['uk'],
  подожди: ['ru'],
  пока: ['ru'],
  пока_не: ['ru'],
  покажи: ['ru', 'uk'],
  показати: ['uk'],
  показать: ['ru'],
  поки: ['uk'],
  поки_не: ['uk'],
  поклади: ['uk'],
  покласти: ['uk'],
  положи: ['ru'],
  положить: ['ru'],
  получи: ['ru'],
  получить: ['ru'],
  поменяй: ['ru'],
  поменять: ['ru'],
  помести: ['ru'],
  поместить: ['ru'],
  поміняй: ['uk'],
  поміняти: ['uk'],
  помісти: ['uk'],
  помістити: ['uk'],
  после: ['ru'],
  потім: ['uk'],
  потом: ['ru'],
  прервать: ['ru'],
  при: ['ru', 'uk'],
  прибери: ['uk'],
  прибрати: ['uk'],
  приховай: ['uk'],
  приховати: ['uk'],
  продовжити: ['uk'],
  продовжуй: ['uk'],
  продолжи: ['ru'],
  продолжить: ['ru'],
  размой: ['ru'],
  размыть: ['ru'],
  розфокусувати: ['uk'],
  розфокусуй: ['uk'],
  с: ['ru'],
  скажи: ['ru', 'uk'],
  сказати: ['uk'],
  сказать: ['ru'],
  скрой: ['ru'],
  скрыть: ['ru'],
  со: ['ru'],
  событие: ['ru'],
  создай: ['ru'],
  создать: ['ru'],
  спрятать: ['ru'],
  спрячь: ['ru'],
  стабилизировать: ['ru'],
  стабілізувати: ['uk'],
  створи: ['uk'],
  створити: ['uk'],
  стоп: ['ru', 'uk'],
  сфокусировать: ['ru'],
  сфокусируй: ['ru'],
  сфокусувати: ['uk'],
  сфокусуй: ['uk'],
  сховай: ['uk'],
  сховати: ['uk'],
  та: ['uk'],
  тогда: ['ru'],
  тоді: ['uk'],
  трансформировать: ['ru'],
  трансформируй: ['ru'],
  трансформувати: ['uk'],
  трансформуй: ['uk'],
  у: ['uk'],
  убери: ['ru'],
  убрать: ['ru'],
  увеличить: ['ru'],
  увеличь: ['ru'],
  удали: ['ru'],
  удалить: ['ru'],
  уменьши: ['ru'],
  уменьшить: ['ru'],
  установи: ['ru'],
  установить: ['ru'],
  установить_пакет: ['ru'],
  фокус: ['ru', 'uk'],
  чекай: ['uk'],
  чекати: ['uk'],
  якщо: ['uk'],
  אז: ['he'],
  אחרי: ['he'],
  אחרת: ['he'],
  איפה: ['he'],
  אירוע: ['he'],
  אל: ['he'],
  אם: ['he'],
  'אם לא': ['he'],
  אמור: ['he'],
  אסינכרוני: ['he'],
  את: ['he'],
  אתחל: ['he'],
  ב: ['he'],
  בזמן: ['he'],
  בחר: ['he'],
  ביפ: ['he'],
  'ברירת מחדל': ['he'],
  'ג׳אווהסקריפט': ['he'],
  גם: ['he'],
  הבא: ['he'],
  הגדל: ['he'],
  הגדר: ['he'],
  הגשה: ['he'],
  'הדלק כבה': ['he'],
  הוסף: ['he'],
  'הוסף אחד': ['he'],
  'הוסף בהתחלה': ['he'],
  'הוסף בסוף': ['he'],
  הורד: ['he'],
  הזנה: ['he'],
  החבא: ['he'],
  החזר: ['he'],
  החלף: ['he'],
  היכן: ['he'],
  הכן: ['he'],
  הכנס: ['he'],
  המר: ['he'],
  המשך: ['he'],
  המתן: ['he'],
  הנח: ['he'],
  הנפש: ['he'],
  הסר: ['he'],
  'הסר מיקוד': ['he'],
  הסתר: ['he'],
  העתק: ['he'],
  הפוך: ['he'],
  הפחת: ['he'],
  הפסק: ['he'],
  הפעל: ['he'],
  הצג: ['he'],
  הקדם: ['he'],
  הקטן: ['he'],
  הראה: ['he'],
  השג: ['he'],
  התחל: ['he'],
  התייצב: ['he'],
  התמקד: ['he'],
  התנהגות: ['he'],
  התקן: ['he'],
  ואז: ['he'],
  וגם: ['he'],
  זמן: ['he'],
  זרוק: ['he'],
  חזור: ['he'],
  חכה: ['he'],
  טען: ['he'],
  טשטש: ['he'],
  כאשר: ['he'],
  'כל עוד': ['he'],
  כש: ['he'],
  ל: ['he'],
  לחיצה: ['he'],
  לך: ['he'],
  לכל: ['he'],
  לפני: ['he'],
  לתוך: ['he'],
  מ: ['he'],
  מאת: ['he'],
  מדוד: ['he'],
  מחק: ['he'],
  מן: ['he'],
  מעבר: ['he'],
  מקד: ['he'],
  מתג: ['he'],
  נווט: ['he'],
  סוף: ['he'],
  סיום: ['he'],
  עבור: ['he'],
  עד: ['he'],
  עדכון: ['he'],
  על: ['he'],
  עם: ['he'],
  'עצב מחדש': ['he'],
  עצור: ['he'],
  צא: ['he'],
  צור: ['he'],
  צרף: ['he'],
  קבל: ['he'],
  קבע: ['he'],
  קח: ['he'],
  קלט: ['he'],
  קליק: ['he'],
  קרא: ['he'],
  ריחוף: ['he'],
  רנדר: ['he'],
  רשום: ['he'],
  שבור: ['he'],
  שגר: ['he'],
  שים: ['he'],
  שינוי: ['he'],
  שכפל: ['he'],
  שלח: ['he'],
  שליחה: ['he'],
  آخر: ['ar'],
  أخبر: ['ar'],
  أخف: ['ar'],
  أخفِ: ['ar'],
  أرسل: ['ar'],
  أزل: ['ar'],
  أضف: ['ar'],
  أطلق: ['ar'],
  أظهر: ['ar'],
  ألحق: ['ar'],
  أنشئ: ['ar'],
  أنقص: ['ar'],
  أوقف: ['ar'],
  أيضاً: ['ar'],
  أين: ['ar'],
  إذا: ['ar'],
  إلى: ['ar'],
  اجعل: ['ar'],
  احذف: ['ar'],
  احصل: ['ar'],
  احضر: ['ar'],
  اختر: ['ar'],
  اخرج: ['ar'],
  اخف: ['ar'],
  اخفي: ['ar'],
  اذهب: ['ar'],
  ارجع: ['ar'],
  ارسم: ['ar'],
  ارفع: ['ar'],
  ارم: ['ar'],
  ارمِ: ['ar'],
  استبدل: ['ar'],
  استدع: ['ar'],
  استقر: ['ar'],
  استنسخ: ['ar'],
  اصنع: ['ar'],
  اضبط: ['ar'],
  اضف: ['ar'],
  اظهر: ['ar'],
  اعرض: ['ar'],
  افتراضي: ['ar'],
  امسح: ['ar'],
  انتظر: ['ar'],
  انتقال: ['ar'],
  انتقل: ['ar'],
  انتهى: ['ar'],
  انسخ: ['ar'],
  انقص: ['ar'],
  ب: ['ar'],
  بـ: ['ar'],
  باستخدام: ['ar'],
  بدء: ['ar'],
  بدل: ['ar'],
  بدّل: ['ar'],
  بعد: ['ar'],
  بعدها: ['ar'],
  بينما: ['ar'],
  تبادل: ['ar'],
  تثبيت: ['ar'],
  تركيز: ['ar'],
  تشغيل: ['ar'],
  تهيئة: ['ar'],
  توقف: ['ar'],
  ثبّت: ['ar'],
  ثم: ['ar'],
  ثمّ: ['ar'],
  جافاسكربت: ['ar'],
  جلب: ['ar'],
  حتى: ['ar'],
  حدث: ['ar'],
  حدد: ['ar'],
  حوّل: ['ar'],
  حين: ['ar'],
  خذ: ['ar'],
  'خلاف ذلك': ['ar'],
  ركز: ['ar'],
  زد: ['ar'],
  زِد: ['ar'],
  سبق: ['ar'],
  سجل: ['ar'],
  سلوك: ['ar'],
  شوش: ['ar'],
  صفّر: ['ar'],
  ضبابية: ['ar'],
  ضع: ['ar'],
  عُد: ['ar'],
  على: ['ar'],
  عند: ['ar'],
  عندما: ['ar'],
  عيّن: ['ar'],
  غير: ['ar'],
  غيّر: ['ar'],
  فعّل: ['ar'],
  في: ['ar'],
  قبل: ['ar'],
  قِس: ['ar'],
  قلل: ['ar'],
  قياس: ['ar'],
  كرر: ['ar'],
  لدى: ['ar'],
  لكل: ['ar'],
  متزامن: ['ar'],
  من: ['ar'],
  نادِ: ['ar'],
  نهاية: ['ar'],
  وأيضاً: ['ar'],
  وإلا: ['ar'],
  واصل: ['ar'],
  अगर: ['hi'],
  अंत: ['hi'],
  असिंक: ['hi'],
  इनपुट: ['hi'],
  इंस्टॉल: ['hi'],
  ऊपर_रखें: ['hi'],
  और: ['hi'],
  कहाँ: ['hi'],
  'के बाद': ['hi'],
  'के लिए': ['hi'],
  केंद्रित: ['hi'],
  कॉपी: ['hi'],
  कॉल: ['hi'],
  को: ['hi'],
  क्लिक: ['hi'],
  क्लोन: ['hi'],
  घटना: ['hi'],
  घटा: ['hi'],
  घटाएं: ['hi'],
  चुनें: ['hi'],
  छिपा: ['hi'],
  छिपाएं: ['hi'],
  जब: ['hi'],
  'जब तक': ['hi'],
  जमा: ['hi'],
  जा: ['hi'],
  जाएं: ['hi'],
  जारी: ['hi'],
  जेएस: ['hi'],
  जोड़: ['hi'],
  जोड़ें: ['hi'],
  जोड़ें_अंत: ['hi'],
  जोड़ें_शुरू: ['hi'],
  टॉगल: ['hi'],
  ट्रिगर: ['hi'],
  डाल: ['hi'],
  डालें: ['hi'],
  डिफ़ॉल्ट: ['hi'],
  तक: ['hi'],
  तब: ['hi'],
  तोड़ें: ['hi'],
  दर्ज: ['hi'],
  दिखा: ['hi'],
  दिखाएं: ['hi'],
  दोहरा: ['hi'],
  दोहराएं: ['hi'],
  धुंधला: ['hi'],
  'नहीं तो': ['hi'],
  निर्धारित: ['hi'],
  पर: ['hi'],
  परिवर्तन: ['hi'],
  पहले: ['hi'],
  पाएं: ['hi'],
  प्रतिलिपि: ['hi'],
  प्रतीक्षा: ['hi'],
  प्राप्त: ['hi'],
  प्रारंभ: ['hi'],
  फिर: ['hi'],
  फेंक: ['hi'],
  फेंकें: ['hi'],
  फोकस: ['hi'],
  फोकस_हटाएं: ['hi'],
  बढ़ा: ['hi'],
  बढ़ाएं: ['hi'],
  बता: ['hi'],
  बताएं: ['hi'],
  बदल: ['hi'],
  बदलाव: ['hi'],
  बदलें: ['hi'],
  बदलें_स्थान: ['hi'],
  बना: ['hi'],
  बनाएं: ['hi'],
  बाद: ['hi'],
  बाहर: ['hi'],
  बीप: ['hi'],
  बुलाएं: ['hi'],
  भेज: ['hi'],
  भेजें: ['hi'],
  मापें: ['hi'],
  मिटाएं: ['hi'],
  में: ['hi'],
  यदि: ['hi'],
  रख: ['hi'],
  रखें: ['hi'],
  रुकें: ['hi'],
  रूपांतर: ['hi'],
  रेंडर: ['hi'],
  रोक: ['hi'],
  रोकें: ['hi'],
  लाएं: ['hi'],
  ले: ['hi'],
  लें: ['hi'],
  लॉग: ['hi'],
  लौटा: ['hi'],
  लौटाएं: ['hi'],
  वरना: ['hi'],
  व्यवहार: ['hi'],
  संक्रमण: ['hi'],
  सबमिट: ['hi'],
  समाप्त: ['hi'],
  से: ['hi'],
  'से पहले': ['hi'],
  सेट: ['hi'],
  स्थिर: ['hi'],
  हटा: ['hi'],
  हटाएं: ['hi'],
  होवर: ['hi'],
  অপেক্ষা: ['bn'],
  অ্যাসিঙ্ক: ['bn'],
  আগে: ['bn'],
  আচরণ: ['bn'],
  আনুন: ['bn'],
  ইনপুট: ['bn'],
  ইনস্টল: ['bn'],
  উপরে_রাখুন: ['bn'],
  এ: ['bn'],
  এবং: ['bn'],
  কপি: ['bn'],
  কমান: ['bn'],
  কল: ['bn'],
  কে: ['bn'],
  কোথায়: ['bn'],
  ক্লিক: ['bn'],
  ক্লোন: ['bn'],
  ঘটনা: ['bn'],
  'চালিয়ে যান': ['bn'],
  'ছুঁড়ে দিন': ['bn'],
  জন্য: ['bn'],
  জমা: ['bn'],
  জেএস: ['bn'],
  ঝাপসা: ['bn'],
  টগল: ['bn'],
  ট্রিগার: ['bn'],
  ডাকুন: ['bn'],
  ডিফল্ট: ['bn'],
  তখন: ['bn'],
  তারপর: ['bn'],
  তে: ['bn'],
  'তৈরি করুন': ['bn'],
  থামাও: ['bn'],
  থামুন: ['bn'],
  থেকে: ['bn'],
  দিয়ে: ['bn'],
  দেখাও: ['bn'],
  দেখান: ['bn'],
  নতুবা: ['bn'],
  'না হলে': ['bn'],
  নিক্ষেপ: ['bn'],
  নিন: ['bn'],
  নির্ধারণ: ['bn'],
  নে: ['bn'],
  পরিবর্তন: ['bn'],
  পরে: ['bn'],
  পর্যন্ত: ['bn'],
  পাঠাও: ['bn'],
  পাঠান: ['bn'],
  পান: ['bn'],
  পুনরাবৃত্তি: ['bn'],
  প্রতিলিপি: ['bn'],
  প্রবেশ: ['bn'],
  ফিরুন: ['bn'],
  'ফেরত দিন': ['bn'],
  ফোকাস: ['bn'],
  ফোকাস_সরান: ['bn'],
  বদল: ['bn'],
  বল: ['bn'],
  বলুন: ['bn'],
  বাছুন: ['bn'],
  বাড়ান: ['bn'],
  বানান: ['bn'],
  'বার বার': ['bn'],
  বীপ: ['bn'],
  বৃদ্ধি: ['bn'],
  বের: ['bn'],
  ভাঙুন: ['bn'],
  ভিতরে: ['bn'],
  মনোযোগ: ['bn'],
  মাপুন: ['bn'],
  মুছুন: ['bn'],
  যখন: ['bn'],
  যতক্ষণ: ['bn'],
  যদি: ['bn'],
  যাও: ['bn'],
  যান: ['bn'],
  যোগ: ['bn'],
  'যোগ করুন': ['bn'],
  রাখ: ['bn'],
  রাখুন: ['bn'],
  রূপান্তর: ['bn'],
  রেকর্ড: ['bn'],
  রেন্ডার: ['bn'],
  লগ: ['bn'],
  লুকাও: ['bn'],
  লুকান: ['bn'],
  শুরু: ['bn'],
  'শুরুতে যোগ': ['bn'],
  শেষ: ['bn'],
  'শেষে যোগ': ['bn'],
  সংক্রমণ: ['bn'],
  সমাপ্ত: ['bn'],
  সরান: ['bn'],
  'সরিয়ে ফেলুন': ['bn'],
  সাবমিট: ['bn'],
  সেট: ['bn'],
  স্থির: ['bn'],
  হোভার: ['bn'],
  হ্রাস: ['bn'],
  กรอก: ['th'],
  กลับ: ['th'],
  ก่อน: ['th'],
  กำหนด: ['th'],
  ขณะที่: ['th'],
  ขัดจังหวะ: ['th'],
  คงที่: ['th'],
  คลิก: ['th'],
  คัดลอก: ['th'],
  ค่าเริ่มต้น: ['th'],
  คืนค่า: ['th'],
  โคลน: ['th'],
  จนถึง: ['th'],
  จบ: ['th'],
  จาก: ['th'],
  เจเอส: ['th'],
  ซ่อน: ['th'],
  ด้วย: ['th'],
  ดึงข้อมูล: ['th'],
  ตอน: ['th'],
  ต่อไป: ['th'],
  ตั้ง: ['th'],
  ติดตั้ง: ['th'],
  ถ้า: ['th'],
  ทริกเกอร์: ['th'],
  ทำซ้ำ: ['th'],
  ที่ไหน: ['th'],
  ใน: ['th'],
  ในขณะที่: ['th'],
  บอก: ['th'],
  บันทึก: ['th'],
  บี๊บ: ['th'],
  เบลอ: ['th'],
  ป้อน: ['th'],
  เปลี่ยน: ['th'],
  เปลี่ยนแปลง: ['th'],
  เปลี่ยนผ่าน: ['th'],
  แปลงร่าง: ['th'],
  ไป: ['th'],
  ไปที่: ['th'],
  ไปยัง: ['th'],
  พฤติกรรม: ['th'],
  เพิ่ม: ['th'],
  เพิ่มค่า: ['th'],
  เพิ่มท้าย: ['th'],
  เพิ่มหน้า: ['th'],
  โฟกัส: ['th'],
  เมื่อ: ['th'],
  ไม่งั้น: ['th'],
  ไม่เช่นนั้น: ['th'],
  ยื่น: ['th'],
  โยน: ['th'],
  รอ: ['th'],
  รับ: ['th'],
  รับค่า: ['th'],
  เริ่มต้น: ['th'],
  เรียก: ['th'],
  ลดค่า: ['th'],
  ลบ: ['th'],
  ลบออก: ['th'],
  เลือก: ['th'],
  แล้ว: ['th'],
  และ: ['th'],
  วัด: ['th'],
  วาง: ['th'],
  วางเมาส์: ['th'],
  ส่ง: ['th'],
  ส่งข้อมูล: ['th'],
  สร้าง: ['th'],
  สลับ: ['th'],
  สลับที่: ['th'],
  สำเนา: ['th'],
  สำหรับ: ['th'],
  แสดง: ['th'],
  แสดงผล: ['th'],
  ใส่: ['th'],
  หยุด: ['th'],
  หลัง: ['th'],
  หาก: ['th'],
  เหตุการณ์: ['th'],
  ออก: ['th'],
  อะซิงค์: ['th'],
  โฮเวอร์: ['th'],
  가져오다: ['ko'],
  각각: ['ko'],
  감소: ['ko'],
  계속: ['ko'],
  교환: ['ko'],
  그다음: ['ko'],
  그런후: ['ko'],
  그리고: ['ko'],
  기본값: ['ko'],
  까지: ['ko'],
  끝: ['ko'],
  끝에추가: ['ko'],
  나가기: ['ko'],
  넣기: ['ko'],
  넣다: ['ko'],
  놓기: ['ko'],
  대기: ['ko'],
  던지다: ['ko'],
  덧붙이다: ['ko'],
  동안: ['ko'],
  동작: ['ko'],
  때: ['ko'],
  또한: ['ko'],
  렌더링: ['ko'],
  로: ['ko'],
  로그: ['ko'],
  를: ['ko'],
  마침: ['ko'],
  만들다: ['ko'],
  만약: ['ko'],
  말하다: ['ko'],
  및: ['ko'],
  바꾸다: ['ko'],
  반복: ['ko'],
  반환: ['ko'],
  변경: ['ko'],
  변형: ['ko'],
  변환: ['ko'],
  보내다: ['ko'],
  보이기: ['ko'],
  보이다: ['ko'],
  복사: ['ko'],
  복제: ['ko'],
  부터: ['ko'],
  블러: ['ko'],
  비동기: ['ko'],
  비프: ['ko'],
  삭제: ['ko'],
  선두추가: ['ko'],
  선택: ['ko'],
  설정: ['ko'],
  설치: ['ko'],
  숨기기: ['ko'],
  숨기다: ['ko'],
  시: ['ko'],
  아니면: ['ko'],
  안정: ['ko'],
  앞에추가: ['ko'],
  어디: ['ko'],
  얻다: ['ko'],
  에: ['ko'],
  에서: ['ko'],
  으로: ['ko'],
  을: ['ko'],
  의: ['ko'],
  이동: ['ko'],
  이벤트: ['ko'],
  입력: ['ko'],
  전에: ['ko'],
  정지: ['ko'],
  제거: ['ko'],
  제출: ['ko'],
  중단: ['ko'],
  증가: ['ko'],
  초기화: ['ko'],
  추가: ['ko'],
  측정: ['ko'],
  클릭: ['ko'],
  토글: ['ko'],
  트랜지션: ['ko'],
  트리거: ['ko'],
  패치: ['ko'],
  포커스: ['ko'],
  표시: ['ko'],
  '할 때': ['ko'],
  호버: ['ko'],
  호출: ['ko'],
  후에: ['ko'],
  アシンク: ['ja'],
  アニメーション: ['ja'],
  アペンド: ['ja'],
  イニット: ['ja'],
  イベント: ['ja'],
  インクリメント: ['ja'],
  インストール: ['ja'],
  おわり: ['ja'],
  から: ['ja'],
  クローン: ['ja'],
  ゲット: ['ja'],
  コール: ['ja'],
  コピー: ['ja'],
  スロー: ['ja'],
  スワップ: ['ja'],
  そうでなければ: ['ja'],
  そして: ['ja'],
  それから: ['ja'],
  それ以外: ['ja'],
  ために: ['ja'],
  で: ['ja'],
  デクリメント: ['ja'],
  デフォルト: ['ja'],
  テル: ['ja'],
  と: ['ja'],
  とき: ['ja'],
  ときに: ['ja'],
  トグル: ['ja'],
  トグルする: ['ja'],
  どこ: ['ja'],
  トランジション: ['ja'],
  トリガー: ['ja'],
  ナビゲート: ['ja'],
  なら: ['ja'],
  ならば: ['ja'],
  に: ['ja'],
  の: ['ja'],
  の間: ['ja'],
  ハルト: ['ja'],
  ビープ: ['ja'],
  ビヘイビア: ['ja'],
  フェッチ: ['ja'],
  フォーカス: ['ja'],
  フォーカス解除: ['ja'],
  ブラー: ['ja'],
  プリペンド: ['ja'],
  へ: ['ja'],
  ぼかし: ['ja'],
  また: ['ja'],
  まで: ['ja'],
  メジャー: ['ja'],
  モーフ: ['ja'],
  もし: ['ja'],
  リターン: ['ja'],
  リピート: ['ja'],
  ログ: ['ja'],
  を: ['ja'],
  中断: ['ja', 'zh'],
  为: ['zh'],
  之前: ['zh'],
  之后: ['zh'],
  事件: ['zh'],
  事象: ['ja'],
  于: ['zh'],
  交换: ['zh'],
  交換: ['ja'],
  从: ['zh'],
  以: ['zh'],
  伝える: ['ja'],
  何时: ['zh'],
  作る: ['ja'],
  作成: ['ja'],
  停止: ['ja', 'zh'],
  先頭に追加: ['ja'],
  先頭追加: ['ja'],
  克隆: ['zh'],
  入れる: ['ja'],
  入れ替え: ['ja'],
  减少: ['zh'],
  出力: ['ja'],
  切り替え: ['ja'],
  切り替える: ['ja'],
  切换: ['zh'],
  初始化: ['zh'],
  初期化: ['ja'],
  删除: ['zh'],
  到: ['zh'],
  制作: ['zh'],
  削除: ['ja'],
  削除する: ['ja'],
  前: ['ja'],
  前に: ['ja'],
  前往: ['zh'],
  前置: ['zh'],
  加: ['zh'],
  加える: ['ja'],
  去掉: ['zh'],
  发送: ['zh'],
  取り除く: ['ja'],
  取る: ['ja'],
  取得: ['ja', 'zh'],
  取得する: ['ja'],
  变化: ['zh'],
  变形: ['zh'],
  各: ['ja'],
  否则: ['zh'],
  告诉: ['zh'],
  呼び出し: ['ja'],
  呼ぶ: ['ja'],
  和: ['zh'],
  哪里: ['zh'],
  在: ['zh'],
  '在...时': ['zh'],
  増やす: ['ja'],
  増加: ['ja'],
  增加: ['zh'],
  変形: ['ja'],
  変換: ['ja'],
  复制: ['zh'],
  失焦: ['zh'],
  如果: ['zh'],
  安定: ['ja'],
  安装: ['zh'],
  完: ['zh'],
  導入: ['ja'],
  展示: ['zh'],
  并且: ['zh'],
  异步: ['zh'],
  引き金: ['ja'],
  当: ['zh'],
  待つ: ['ja'],
  待機: ['ja'],
  後: ['ja'],
  後に: ['ja'],
  悬停: ['zh'],
  悬浮: ['zh'],
  戻る: ['ja'],
  把: ['zh'],
  抓取: ['zh'],
  投げる: ['ja'],
  抛出: ['zh'],
  拿取: ['zh'],
  持续: ['zh'],
  振る舞い: ['ja'],
  接着: ['zh'],
  描画: ['ja'],
  提交: ['zh'],
  改变: ['zh'],
  放: ['zh'],
  放入: ['zh'],
  放置: ['zh'],
  既定: ['ja'],
  日志: ['zh'],
  显示: ['zh'],
  時: ['ja'],
  末尾に追加: ['ja'],
  末尾追加: ['ja'],
  次に: ['ja'],
  止める: ['ja'],
  测量: ['zh'],
  添加: ['zh'],
  減らす: ['ja'],
  減少: ['ja'],
  測定: ['ja'],
  渲染: ['zh'],
  点击: ['zh'],
  然后: ['zh'],
  用: ['zh'],
  由: ['zh'],
  発火: ['ja'],
  直到: ['zh'],
  移動: ['ja'],
  移除: ['zh'],
  稳定: ['zh'],
  等待: ['zh'],
  終わり: ['ja'],
  終了: ['ja'],
  终止: ['zh'],
  结束: ['zh'],
  継続: ['ja'],
  続ける: ['ja'],
  继续: ['zh'],
  繰り返し: ['ja'],
  繰り返す: ['ja'],
  置く: ['ja'],
  而且: ['zh'],
  聚焦: ['zh'],
  获取: ['zh'],
  获得: ['zh'],
  落ち着く: ['ja'],
  蜂鸣: ['zh'],
  行く: ['ja'],
  行为: ['zh'],
  表示: ['ja'],
  表示する: ['ja'],
  複製: ['ja'],
  見せる: ['ja'],
  触发: ['zh'],
  計測: ['ja'],
  記録: ['ja'],
  設定: ['ja'],
  設定する: ['ja'],
  设定: ['zh'],
  设置: ['zh'],
  调用: ['zh'],
  转换: ['zh'],
  输入: ['zh'],
  迄: ['ja'],
  过渡: ['zh'],
  返す: ['ja'],
  返回: ['zh'],
  进入: ['zh'],
  追加: ['ja', 'zh'],
  追加する: ['ja'],
  退出: ['ja', 'zh'],
  送る: ['ja'],
  送信: ['ja'],
  选取: ['zh'],
  遷移: ['ja'],
  選択: ['ja'],
  重复: ['zh'],
  間: ['ja'],
  附加: ['zh'],
  隐藏: ['zh'],
  隠す: ['ja'],
  集中: ['ja'],
  非同期: ['ja'],
  非表示: ['ja'],
  非表示にする: ['ja'],
  预置: ['zh'],
  默认: ['zh'],
};

/**
 * Unicode script ranges for non-Latin script detection.
 * Provides instant language identification for CJK, Arabic, Cyrillic, etc.
 */
export const SCRIPT_RANGES: readonly {
  start: number;
  end: number;
  languages: readonly string[];
}[] = [
  { start: 0x3040, end: 0x309f, languages: ['ja'] },
  { start: 0x30a0, end: 0x30ff, languages: ['ja'] },
  { start: 0x4e00, end: 0x9fff, languages: ['ja', 'zh'] },
  { start: 0xac00, end: 0xd7af, languages: ['ko'] },
  { start: 0x600, end: 0x6ff, languages: ['ar'] },
  { start: 0x590, end: 0x5ff, languages: ['he'] },
  { start: 0x400, end: 0x4ff, languages: ['ru', 'uk'] },
  { start: 0x900, end: 0x97f, languages: ['hi'] },
  { start: 0x980, end: 0x9ff, languages: ['bn'] },
  { start: 0xe00, end: 0xe7f, languages: ['th'] },
];

/**
 * Total keywords: 2431
 * Total languages: 24
 * Ambiguous keywords (match 2+ languages): 148
 */
